import React, { useContext, useEffect,useState } from "react";
import './published.css'
import HeadBar from "../../../components/headBar/headBar";
import { MenuElement } from "../../../components/types/types";
import { Link, useNavigate } from "react-router-dom";
import { fetchWithRefreshRestau } from "../../../components/types/types";
import { AppContext } from "../../../context/AppContext";
import Footer from "../../HomeScreen/Footer/Footer";
const PublishedPage = () => {
    const {idRestaurant} = useContext(AppContext)
    const [type,setType] = useState<string>('')
    const [typeDisplay,setTypeDisplay] = useState<string>('')
    const [Menu,setMenu] = useState<MenuElement[][]>([])
    const [listDesc,setListDesc] = useState<[[string,string],string,[string|ArrayBuffer|null,string]][]>([])
    const [schedule,setSchedule] = useState<{ [key: string]: [string, string][] | string }>({ })
    const [devanture,setDevanture] = useState<string>('')
    const [filters,setFilters] = useState<string[]>([])
    const [showSend,setShowSend] = useState<boolean>(false)
    const [msgShowSend,setMsgShowSend] = useState<string>('')
    const [defCuisine,setDefCuisine] = useState("")
    const [infoIsLoad,setInfoIsLoad] = useState(false)
    useEffect(() => {
        const recupInfo = async () => {
                const token = localStorage.getItem('token');
                try {
                    const response = await fetchWithRefreshRestau(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/getInfoBeforePublication`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        },
                        body: JSON.stringify({ idrestaurant:idRestaurant})
                    });
                    if(response) {
                        const data = await response.json()
                        setSchedule(data.info.schedule)
                        setMenu(data.info.menu)
                        setListDesc(data.info.listdesc)
                        setDevanture(data.info.devanture)
                        setFilters(data.info.filters)
                        setType(data.info.type)
                        setTypeDisplay(data.info.type_display)
                        setDefCuisine(data.info.def_cuisine)
                        setInfoIsLoad(true)
                    }
                } catch (error) {
                    console.error("Erreur lors de la connexion :", error);
                }
        }
        recupInfo()
    },[])

    const PossiblePublished = () => {
        return Menu && listDesc && schedule && filters && Menu.length && listDesc.length && Object.keys(schedule).length && devanture && filters.length && type && typeDisplay && defCuisine
    }

    const clickPublished = async () => {
        if(Menu && listDesc && schedule && filters && Menu.length && listDesc.length && Object.keys(schedule).length && devanture && filters.length && type && defCuisine) {
            const token = localStorage.getItem('token');
            const response = await fetchWithRefreshRestau(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/sendPublication`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                credentials: 'include',
                body: JSON.stringify({
                    idrestaurant: idRestaurant
                })
            });
    
            if(response) {

                const data = await response.json();
                if (data.success) {
                    setMsgShowSend('Votre demande de publication a bien été envoyée.')
                    setShowSend(true)
                    setTimeout(() => {
                        setShowSend(false)
                    },5000)
                } else {
                    setShowSend(true)
                    if (data.message === 'Demande en cours de traitement') setMsgShowSend(`Vous avez déjà envoyé une demande. Nous vous contacterons dès qu'elle aura été traitée.`)
                    else if (data.message === 'not-sub') setMsgShowSend(`Vous ne pouvez pas envoyer de demande tant que votre abonnement n’est pas actif.`)
                    else setMsgShowSend('Une erreur est survenue. Veuillez réessayer plus tard.')
                    setTimeout(() => {
                        setShowSend(false)
                    },5000)
                }
            }else {
                setMsgShowSend('Une erreur est survenue. Veuillez réessayer plus tard.')
                setShowSend(true)
                setTimeout(() => {
                    setShowSend(false)
                },5000)
                return; 
            }
        }
    }
    const payloadModify = {
        isActiveSub: true,
        isModify:true,
    }
    const payloadFilters = {
        isActiveSub: true,
        page:'filters',
    }
    const payloadSchedules = {
        isActiveSub: true,
        page:'schedules',
    }

    const encoded = btoa(JSON.stringify(payloadModify))
    const linkModify = `/modifyInfo/${encoded}`
    const encodedFilter = btoa(JSON.stringify(payloadFilters))
    const linkFilter = `/modifyInfo/${encodedFilter}`
    const encodedSchedules = btoa(JSON.stringify(payloadSchedules))
    const linkSchedules = `/modifyInfo/${encodedSchedules}`

    const navigate = useNavigate()
    const handleOpenHomeModifyMenu = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await fetchWithRefreshRestau(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/acquireLockEditMenu`,{
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                    },
                    credentials: "include",
                    body: JSON.stringify({}),
                }
            );
            const data = await response?.json();
            if (!response || !data?.success || !data?.token) {
                return;
            }
            navigate("/homeModifyMenu",{state: {menuEditLockToken: data.token}});
        } catch (error) {
            return;
        }
    }

    return (
        <>
        <div className="containerPublished secondaryBack">
            <HeadBar textBackButton="Retour" link="/restaurateurLogin" title="Publier mon restaurant"/>
            {infoIsLoad && <>
                {!PossiblePublished() ? 
                    <p className=" largeTextBold" style={{marginTop:'6em',marginBottom:'2em'}}>Il vous reste quelques étapes avant de pouvoir publier votre site.</p>
                    :
                    <>
                        <p className="largeTitleBold" style={{marginTop:'6em',marginBottom:'2em'}}>Vous pouvez maintenant soumettre votre restaurant à une publication !</p>
                        <p className="largeText" style={{width:'80%',marginLeft:'10%'}}>Après avoir cliqué sur “Publier mon restaurant”, nous examinerons vos informations dans les plus brefs délais afin de confirmer la publication de votre restaurant sur QuelResto.</p>
                    </>
                }</>}
            <div className="mainCorp  midText" >
                {infoIsLoad && <>
                    {
                        (!Menu || !Menu.length) && <div>Votre carte est vide, complétez-la. <span className="link smallText  " onClick={handleOpenHomeModifyMenu}>Complétez votre carte</span> <div className="border"></div> </div>
                    }
                    {
                        (!type.length || type.length < 1 || !typeDisplay || typeDisplay.length<5) && <div>Vous n'avez pas défini le type de votre restaurant. Précisez-le pour qu'il soit bien identifié. <Link className="link smallText  " to={linkModify}>Ajoutez un type</Link> <div className="border"></div></div>
                    }
                    {
                        (!defCuisine) && <div>Vous n'avez pas défini votre cuisine. Décrivez-la pour la mettre en valeur. <Link className="link smallText  " to={linkModify}>Définissez votre cuisine</Link> <div className="border"></div></div>
                    }
                    {
                        (!listDesc || !listDesc.length) && <div>Vous n'avez pas complété votre page restaurant,  mettez en avant votre identité !<Link className="link smallText  " to='/modifyDescription'>Complétez votre page restaurant</Link> <div className="border"></div></div>
                    }
                    {
                        (!schedule || !Object.keys(schedule).length) && <div>Vous n'avez pas renseigné vos horaires. Indiquez-les pour informer votre clientèle.<Link className="link smallText  " to={linkSchedules}>Ajoutez vos horaires</Link> <div className="border"></div></div>
                    }
                    {
                        !devanture && <div>Votre restaurant n'a pas de photo principale. Ajoutez-en une dès maintenant.<Link className="link smallText  " to={linkModify}>Ajoutez une photo de devanture</Link> <div className="border"></div></div> 
                    }
                    {
                        (!filters || !filters.length ) && <div>Vos filtres ne sont pas renseignés. Indiquez-les pour faciliter la recherche de votre restaurant. <Link className="link smallText  " style={{whiteSpace:'nowrap'}} to={linkFilter}>Remplissez vos filtres</Link></div>
                    }
                    {showSend && <p className="largeText">{msgShowSend}</p>}
                    <p className={`button midGoldButton ${PossiblePublished() ? 'pointer' : 'locked'} ${showSend && 'locked'}`} onClick={clickPublished}>Publier mon restaurant</p>
                </>
                }
            </div>
        </div>
        <Footer isResto={true}/>
        </>
    )
}
export default PublishedPage